export enum DiscountCodeType {
  MINUS = 'MINUS',
  PERCENT = 'PERCENT',
}
